import { Component, Input, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';


@Component({
  selector: 'app-review-report-offensive',
  templateUrl: './review-report-offensive.component.html',
  styleUrls: ['./review-report-offensive.component.scss']
})
export class ReviewReportOffensiveComponent implements OnInit{
  offensiveType = 'review';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<ReviewReportOffensiveComponent>) { }

  ngOnInit() {
    if (this.data && this.data.offensiveType) {
      this.offensiveType = this.data.offensiveType;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
